import request from '@/plugins/axios'
import store from '@/store'

export function requestApi (requestObj) {
  let reqHeaders = _.cloneDeep(store.state.api.headers)
  _.merge(reqHeaders, requestObj.headers) // 요청 시 설정한 헤더 override

  store.dispatch('RequestApi')

  return request({
    url: requestObj.url,
    callback: requestObj.callback,
    method: requestObj.method || 'POST',
    data: (requestObj.method.toUpperCase() === 'GET') ? null : (requestObj.data || null),
    params: (requestObj.method.toUpperCase() === 'GET') ? (requestObj.data || null) : null,
    responseType: (requestObj.responseType) ? requestObj.responseType: null,
    headers: reqHeaders
  }).then(res => {
    try {
      requestObj.callback(res.data)
    } catch (e) {
      console.error(e)
    }
  }).catch(res => {
    res.data = {
      res_code: res.data.res_code,
      res_msg_ar: res.data.res_msg_ar,
      res_msg_en: res.data.res_msg_en
    }
    requestObj.callback(res.data)
  }).finally(() => {
    store.dispatch('ResponseApi')
  })
}

export default requestApi
